(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(el) {
    if (!el || el.dataset.asWhyInit) return;
    el.dataset.asWhyInit = '1';
    if (reduce) return; // words stay fully inked (CSS default)

    var words = Array.prototype.slice.call(el.querySelectorAll('.as-why__w'));
    var N = words.length;
    var K = Number(el.dataset.wave) || 9;
    var S = Number(el.dataset.start) || 0.7;
    var E = Number(el.dataset.end) || 0.6;
    var root = el.closest('.as-why');
    var lastMark = -1;
    var last = new Array(N).fill(-1);
    var smooth = 0;
    var running = false;
    var raf = 0;

    el.setAttribute('data-reveal', 'ready'); // switches CSS default from --p:1 to --p:0

    function progress() {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var p = (S * vh - r.top) / (r.height + S * vh - E * vh);
      return Math.min(1, Math.max(0, p));
    }

    function frame() {
      var p = progress();
      smooth += (p - smooth) * 0.14;
      if (Math.abs(p - smooth) < 0.0005) smooth = p;
      // The monogram goes from white to navy over the same scroll progress as the words.
      var mark = Math.round(smooth * 100) / 100;
      if (root && mark !== lastMark) {
        lastMark = mark;
        root.style.setProperty('--as-mark-p', mark);
      }
      for (var i = 0; i < N; i++) {
        var local = Math.min(1, Math.max(0, (smooth * (N + K) - i) / K));
        var v = Math.round(local * 100) / 100;
        if (v !== last[i]) {
          last[i] = v;
          words[i].style.setProperty('--p', v);
          words[i].classList.toggle('is-on', v > 0.5);
        }
      }
      raf = running ? requestAnimationFrame(frame) : 0;
    }

    var io = new IntersectionObserver(
      function (entries) {
        running = entries.some(function (e) {
          return e.isIntersecting;
        });
        if (running && !raf) raf = requestAnimationFrame(frame);
      },
      { rootMargin: '30% 0px 30% 0px' }
    );
    io.observe(el);
    frame();
  }

  function boot() {
    document.querySelectorAll('[data-as-why]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-as-why]');
    if (el) {
      delete el.dataset.asWhyInit;
      init(el);
    }
  });
})();
